import { render, staticRenderFns } from "./FeedContentFindNewCompanues.vue?vue&type=template&id=24fb7160"
import script from "./FeedContentFindNewCompanues.vue?vue&type=script&lang=js"
export * from "./FeedContentFindNewCompanues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports